module.exports = __webpack_public_path__ + "static/media/img11.ff770655.jpg";